// extracted by mini-css-extract-plugin
module.exports = {"vacancyContainer":"vacancy_vacancyContainer__rJfMs","vacancies":"vacancy_vacancies__Zl_kD"};